module.exports = __webpack_public_path__ + "assets/img/TikTok.b00e1bed.jpg";